import { reverse, sortBy } from 'lodash';
import { useState } from 'react';

import { tableList } from './const';
import { EmptyStateImage } from '@assets/images';
import TableTemplate2 from '@components/tableTemplate2';
import { useFilters } from '@pages/ConsumerPromotion/hooks/state/useFilters';
import useGetCPList from '@pages/ConsumerPromotion/hooks/query/useGetCPList';

export default function Table() {
    const filters = useFilters();
    const [sortType, setSortType] = useState({ name: '', type: 'default' });
    const { data, isLoading, error } = useGetCPList(filters);

    const onChangeLimit = (e) => filters.set({ page: 1, limit: e.target.value });
    const handlePageClick = ({ selected }) => filters.set({ page: selected + 1 });

    const onSort = (sortName) => {
        if (!data?.page_data) return;
        let type = !sortType || sortType.name !== sortName ? 'asc' : sortType.type === 'asc' ? 'desc' : null;
        setSortType(type ? { name: sortName, type } : null);
        let sorted = [...data?.page_data];
        if (type) {
            sorted = sortBy(sorted, sortName);
            if (type === 'desc') reverse(sorted);
        }
        filters.set({ sort: type ? `${sortName}.${type}` : null });
    };

    if (error || data?.page_data?.length < 0) {
        return (
            <TableTemplate2
                isPagination
                totalData={0}
                totalPage={1}
                page={1}
                onSort={onSort}
                tableList={tableList}
                description="Saat ini, data Consumer Promotion belum tersedia."
            />
        );
    }

    return (
        <TableTemplate2
            isLoading={isLoading}
            data={data?.page_data}
            tableList={tableList}
            totalData={filters.total_data}
            totalPage={filters.total_page}
            handlePageClick={handlePageClick}
            isPagination
            page={filters.page}
            limit={filters.limit}
            onChangeLimit={onChangeLimit}
            isSearch={!!filters.searchParam}
            noResultSearchImage={<EmptyStateImage />}
            onSort={onSort}
            sortType={sortType}
        />
    );
}
